import axios from 'axios'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

const NOTEURL = 'crm/note/'
const NEGOCIOURL = 'crm/negocio/'
const PESSOAURL = 'crm/pessoa/'
const ORGURL = 'crm/organizacao/'
const FUNILURL = 'crm/funil/'
const MOTIVOURL = 'crm/motivo/'
const ORIGEMURL = 'crm/origem/'
const TAGURL = 'crm/tag/'
const EMAILURL = 'crm/email/draft/'
const LEADURL = 'crm/lead/'
const TEMPLATEURL = 'crm/template/'

export default {

  data () {
    return { 
      listDuplicates: [],
      searching: false,
    }
  },

  methods: {
    ///////////////// FUNIL

    async apiFunil (obj, id, responseCallback) {
      let url = FUNILURL
      let metodo = 'post'
      if (id) {
        url = url + id
        metodo = 'put'
      }
      
      let sendData = { funil: obj }
      const data = await apiORDSpost(this.$store, url, sendData, metodo)
      if (!data.items) {
          return
      }

      if (responseCallback) {
          responseCallback(data.items[0])
      }
    },
  
    ///////////////// OBSERVACOES

    async apiNotes (obj, id, responseCallback) {
        let url = NOTEURL
        let metodo = 'post'
        if (id) {
          url = url + id
          metodo = 'put'
        }
        
        let sendData = { note: obj }
        const data = await apiORDSpost(this.$store, url, sendData, metodo)
        if (!data.items) {
            return
        }

        if (responseCallback) {
            responseCallback(data.items[0])
        }
    },

    async apiNotesDelete (id, responseCallback) {
        let url = NOTEURL + id

        const data = await apiORDSdelete(this.$store, url)

        if (responseCallback) {
            responseCallback()
        }
    },



  

    ///////////////// TAG

    async apiTag (obj, id, responseCallback) {
      let url = TAGURL
      let metodo = 'post'
      if (id) {
        url = url + id
        metodo = 'put'
      }
      
      let sendData = { tag: obj }
      const data = await apiORDSpost(this.$store, url, sendData, metodo)
      if (!data.items) {
          return
      }

      if (responseCallback) {
          responseCallback(data.items[0])
      }
  },

  async apiTagDelete (id, responseCallback) {
      let url = TAGURL + id

      const data = await apiORDSdelete(this.$store, url)

      if (responseCallback) {
          responseCallback()
      }
  },


  
    ///////////////// ORIGEM

    async apiOrigem (obj, id, responseCallback) {
      let url = ORIGEMURL
      let metodo = 'post'
      if (id) {
        url = url + id
        metodo = 'put'
      }
      
      let sendData = { origem: obj }
      const data = await apiORDSpost(this.$store, url, sendData, metodo)
      if (!data.items) {
          return
      }

      if (responseCallback) {
          responseCallback(data.items[0])
      }
    },

    async apiOrigemDelete (id, responseCallback) {
      let url = ORIGEMURL + id

      const data = await apiORDSdelete(this.$store, url)

      if (responseCallback) {
          responseCallback()
      }
    },

  
    ///////////////// MOTIVOS

    async apiMotivo (obj, id, responseCallback) {
      let url = MOTIVOURL
      let metodo = 'post'
      if (id) {
        url = url + id
        metodo = 'put'
      }
      
      let sendData = { motivo: obj }
      const data = await apiORDSpost(this.$store, url, sendData, metodo)
      if (data.errmessages) {
        this.errmessages = data.errmessages
        this.$erpToastError('Alguns erros precisam ser corrigidos.')
      } else if (!data.items) {
          return
      }

      if (responseCallback) {
          responseCallback(data.items[0])
      }
  },

  async apiMotivoDelete (id, responseCallback) {
      let url = MOTIVOURL + id

      const data = await apiORDSdelete(this.$store, url)

      if (responseCallback) {
          responseCallback()
      }
  },



    ///////////////// NEGOCIO

    async apiNegocio (obj, id, responseCallback) {
        let url = NEGOCIOURL
        let metodo = 'post'
        if (id) {
          url = url + id
          metodo = 'put'
        }

        let sendData = { negociocrm: obj }
        const data = await apiORDSpost(this.$store, url, sendData, metodo)
        if (!data.items) {
            return
        }

        if (responseCallback) {
            responseCallback(data.items[0])
        }
    },



    //////////////// PESSOAS

    async apiPessoas (obj, id, responseCallback) {
        let url = PESSOAURL
        let metodo = 'post'
        if (id) {
          url = url + id
          metodo = 'put'
        }

        let sendData = {}

        //inclui a organizacao se necessario
        // if (obj.organizacao && obj.organizacao.novo) {
        //   sendData = { orgranizacao: obj.organizacao }
        //   await this.apiOrganizacao(sendData, null, null)
        // }
        
        sendData = { pessoa: obj }
        const data = await apiORDSpost(this.$store, url, sendData, metodo)
        
        if (!data.items) {
            return
        }

        if (responseCallback) {
            responseCallback(data.items[0])
        }
    },

    async apiPessoasDelete (id, responseCallback) {
        let url = PESSOAURL + '/' + id

        const data = await apiORDSdelete(this.$store, url)

        if (responseCallback) {
            responseCallback()
        }
    },


    
    //////////////// ORGANIZACOES

    async apiOrg (obj, id, responseCallback) {
      let url = ORGURL
      let metodo = 'post'
      if (id) {
          url = url + '/' + id
        metodo = 'put'
      }

      let sendData = {}

      sendData = { org: obj }
      const data = await apiORDSpost(this.$store, url, sendData, metodo)
      
      if (!data.items) {
          return
      }

      if (responseCallback) {
          responseCallback(data.items[0])
      }
    },

    async apiOrgDelete (id, responseCallback) {
      let url = ORGURL + '/' + id

      const data = await apiORDSdelete(this.$store, url)

      if (responseCallback) {
          responseCallback()
      }
    },



    async apiAgendaDelete (codagenda, responseCallback) {
      var modulo = 'cg/agenda/' + codagenda
      const data = await apiORDSdelete(this.$store, modulo)
      if (responseCallback) {
        responseCallback()
      }
    },




    //////////////// LEADS

    async apiLead (obj, id, responseCallback) {
      let url = LEADURL
      let metodo = 'post'
      if (id) {
          url = url + id
        metodo = 'put'
      }

      let sendData = {}

      sendData = { lead: obj }
      const data = await apiORDSpost(this.$store, url, sendData, metodo)

      if (!data.items) {
          return
      }

      if (responseCallback) {
          responseCallback(data.items[0])
      }
    },


    async apiLeadDelete (id, responseCallback) {
      let url = LEADURL + id

      const data = await apiORDSdelete(this.$store, url)

      if (responseCallback) {
          responseCallback()
      }

    },



    //////////////// TEMPLATES DE EMAILS

    async apiTemplate (obj, id, responseCallback) {
      let url = TEMPLATEURL
      let metodo = 'post'
      if (id) {
          url = url + id
        metodo = 'put'
      }

      let sendData = {}

      sendData = { template: obj }
      const data = await apiORDSpost(this.$store, url, sendData, metodo)

      if (!data.items) {
          return
      }

      if (responseCallback) {
          responseCallback(data.items[0])
      }
    },


    async apiTemplateDelete (id, responseCallback) {
      let url = TEMPLATEURL + id

      const data = await apiORDSdelete(this.$store, url)

      if (responseCallback) {
          responseCallback()
      }

    },


    //////////////// ENVIO DE EMAILS

    async emailPost (obj, id, responseCallback) {
      let url = EMAILURL
      let metodo = 'post'
      if (id) {
          url = url + id
        metodo = 'put'
      }

      let sendData = {}

      sendData = { email: obj }
      const data = await apiORDSpost(this.$store, url, sendData, metodo)

      if (!data.items) {
          return
      }

      if (responseCallback) {
          responseCallback(data.items[0])
      }
    },


    async apiEmailDelete (id, responseCallback) {
      let url = EMAILURL + id

      const data = await apiORDSdelete(this.$store, url)

      if (responseCallback) {
          responseCallback()
      }

    },



    async apiEmailLido (id, responseCallback) {
      let url = '/crm/email/' + id + '/lido'

      const data = await apiORDSpost(this.$store, url, null, 'post')

      if (responseCallback) {
          responseCallback()
      }

    },



    apiUploadAnexo(objAnexo, responseCallback) {
      let formData = new FormData();
      formData.append('file', objAnexo.selectedFile);

      var url = this.$store.getters.urlOrds + 'docs/' 

      axios.post(url, formData,
          {
            headers: {
                'Content-Type': 'multipart/form-data',
                'ref': 'EMAILCRM',
                'chaveref': objAnexo.codemail,
                'filename': objAnexo.selectedFile.name
            }
          }
      ).then(function(response){
          if (response.data.items) {
            if (responseCallback) {
              let data = response.data.items[0]
              responseCallback(data)
            }
          }
      })

    },

    apiDeleteAnexo(coddoc){
      var url = this.$store.getters.urlOrds + 'docs/' + coddoc

      var self = this
      axios.delete(url).then(function(data){
        self.$erpToastSuccess('Anexo removido')
      })

    },








  }
}





// WEBPACK FOOTER //
// ./src/api/api-crm.js